import { useMemo } from 'react'

import { SUPPORTED_LIBRARY_MESSAGE_TYPES } from '@/app/module/campaigns/component/item/steps/content/types/multimessage/message-snippet'
import { getMessageContentType } from '@/app/module/campaigns/helpers'
import { MessageSnippetType } from '@/app/module/campaigns/types'
import { useGetSnippets } from '@/app/module/user/hooks/use-get-snippets'
import { SelectOption } from '@/app/types'

type UseSnippetsArgs = {
  supportedMessageTypes: SelectOption<string>[]
}

export function useMessageSnippets({ supportedMessageTypes }: UseSnippetsArgs) {
  const snippets = useGetSnippets({ category: 'message' })
  const supportedTypes = useMemo(() => supportedMessageTypes.map((o) => o.value), [supportedMessageTypes])

  const messageSnippets = useMemo(() => {
    return (snippets.data?.snippets || []).flatMap((item): MessageSnippetType[] => {
      const snippet = item.snippet as MessageSnippetType['snippet']
      const type = getMessageContentType(snippet)

      if (!supportedTypes.includes(type) || !SUPPORTED_LIBRARY_MESSAGE_TYPES.includes(type)) {
        return []
      }

      return [
        {
          id: item.id,
          category: 'message',
          file: [],
          snippet,
          userId: item.userId || 0,
          value: item.valid,
        },
      ]
    })
  }, [snippets.data, supportedTypes])

  return {
    ...snippets,
    data: messageSnippets,
    isSupported: messageSnippets.length > 0,
  }
}
